import antdEn from 'antd/es/locale/en_US';
import antdVi from 'antd/es/locale/vi_VN';
import antdTh from 'antd/es/locale/th_TH';
import antdZh from 'antd/es/locale/zh_CN';
import antdJa from 'antd/es/locale/ja_JP';
import antdId from 'antd/es/locale/id_ID';
import { includes, merge } from 'lodash';

import { DEFAULT_CALLBACK_LOCALE, languages } from '../constants/CONSTANTS';
import enTranslations from '../constants/translations/en-US.json';
import viTranslations from '../constants/translations/vi-VN.json';
import thTranslations from '../constants/translations/th-TH.json';
import zhTranslations from '../constants/translations/zh-CN.json';
import jaTranslations from '../constants/translations/ja-JP.json';
import idTranslations from '../constants/translations/id-ID.json';

const localeConfig = {
  en: {
    antd: antdEn,
    translations: enTranslations,
  },
  vi: {
    antd: antdVi,
    translations: merge({}, enTranslations, viTranslations),
  },
  th: {
    antd: antdTh,
    translations: merge({}, enTranslations, thTranslations),
  },
  zh: {
    antd: antdZh,
    translations: merge({}, enTranslations, zhTranslations),
  },
  ja: {
    antd: antdJa,
    translations: merge({}, enTranslations, jaTranslations),
  },
  id: {
    antd: antdId,
    translations: merge({}, enTranslations, idTranslations),
  },
};

/**
 * Define custom formatters here.
 */
export const getFormats = () => ({
  number: {
    usd: { style: 'currency', currency: 'USD' },
  },
});

/**
 * Given browser's locale, returns only locales supported by the app. Defaults to 'en'.
 * Use first time only
 */
export function getAppLocale(browserLocale: string): LocaleType {
  const language = browserLocale.slice(0, 2);
  if (language && includes(languages, language)) {
    return language as LocaleType;
  }
  return DEFAULT_CALLBACK_LOCALE;
}

export function getLocaleMessage(locale: LocaleType) {
  const localMsg = flattenMessages(localeConfig[locale].translations);
  return { locale, localMsg, antdMsg: localeConfig[locale].antd };
}

function flattenMessages(nestedMessages: any, prefix = '') {
  return Object.keys(nestedMessages).reduce((messages: any, key: string) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }
    return messages;
  }, {});
}
